/* eslint-disable react/no-array-index-key */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Table from '../../../components/Table/Table';
import TableContainer from '../../../components/TableContainer/TableContainer';
import TableBody from '../../../components/TableBody/TableBody';
import TableRow from '../../../components/TableRow/TableRow';
import TableCell from '../../../components/TableCell/TableCell';
import TableBtnSets from '../../../components/ConfigTable/TableBtnSets';
import TableHead from '../../../components/TableHead/TableHead';
import PowderBatchTemperatureUpdateDialog from './PowderBatchTemperatureUpdateDialog/PowderBatchTemperatureUdpateDialog';

const SettingConfigPowderBatchTemperatureTableHeadCells = [
  { id: 'powderBatch', numeric: false, disablePadding: true, label: '試燒環編號' },
];

const ConfigTable = ({ tableContentList, editedData, onRowDelete, isLoading }) => {
  const [targetEditRow, setTargetEditRow] = useState(null);

  const handleOpenEditDialog = (targetRow) => {
    setTargetEditRow(targetRow);
  };

  const handleCloseEditDialog = () => {
    setTargetEditRow(null);
  };

  const handleDelete = (targetRow) => {
    onRowDelete(targetRow);
  };

  return (
    <TableContainer isLoading={isLoading}>
      <Table>
        <TableHead
          isCheckBox={false}
          headCells={SettingConfigPowderBatchTemperatureTableHeadCells}
        />
        <TableBody>
          {tableContentList.map((row) => (
            <TableRow
              tabIndex={-1}
              key={row.rowId}
              style={{ verticalAlign: editedData?.error ? 'top' : 'middle' }}
            >
              <TableCell>{row.powderBatch}</TableCell>
              <TableCell align="right">
                <TableBtnSets
                  isDelete
                  handleEditing={() => handleOpenEditDialog(row)}
                  handleDelete={() => handleDelete(row)}
                  canDelete
                  canEdit
                  deleteConfirmMessage={`是否確認刪除試燒環 ${row.powderBatch} 的溫度表？`}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {targetEditRow !== null && (
        <PowderBatchTemperatureUpdateDialog
          isOpen={targetEditRow !== null}
          onClose={handleCloseEditDialog}
          targetRow={targetEditRow}
        />
      )}
    </TableContainer>
  );
};

ConfigTable.defaultProps = {
  onRowDelete: null,
};

ConfigTable.propTypes = {
  onRowDelete: PropTypes.func,
  isLoading: PropTypes.bool,
  tableContentList: PropTypes.array.isRequired,
  editedData: PropTypes.object,
};

export default ConfigTable;
